module.exports = function getResource(label) {
    const resources = {
        free: 'FREE',
        value: 'value'
    };
    return resources[label];
};
